// extracted by mini-css-extract-plugin
export default {"billing__payment":"Payment_billing__payment__hN7y0","billing__payment__container":"Payment_billing__payment__container__8AwfN"};